"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var canvas_element_1 = require("./canvas-element");
var Render = (function () {
    function Render() {
        this.imageHeadPath = 'img/coin/anim/shine_1/shine_1_030.png';
        this.imageTailPath = 'img/coin/anim/shine_2/shine_2_030.png';
        this.dice2Path = 'img/coin/coin_dice_2.png';
    }
    Render.prototype.renderAllElements = function (elems, wasAnimated) {
        var _this = this;
        elems.forEach(function (elem) {
            if (wasAnimated.includes(elem.ChallID)) {
                _this.renderParticular(elem, elem.HeadOrTails);
            }
            else {
                _this.renderParticular(elem);
            }
        });
    };
    Render.prototype.renderParticular = function (challenge, headTail) {
        if (headTail === void 0) { headTail = 0; }
        var coinImage = new Image();
        var canvasElement = new canvas_element_1.default("canvas" + challenge.ChallID);
        if (canvasElement.getElement()) {
            var ctx_1 = canvasElement.getElement().getContext('2d');
            if (ctx_1) {
                if (headTail > 0) {
                    var test_1 = null;
                    if (headTail === 1) {
                        coinImage.src = this.imageHeadPath;
                        coinImage.onload = function () {
                            ctx_1 ? ctx_1.drawImage(coinImage, 30, -40, canvasElement.width(80), canvasElement.height(150)) : '';
                            test_1 = document.getElementsByClassName("coins-card-id-" + challenge.ChallID)[0];
                            test_1 ? test_1.querySelector('.coins-body-left') ? test_1.querySelector('.coins-body-left')
                                .classList.add('my-glower', 'no-animation') : '' : '';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-upper p").innerHTML =
                                challenge.NameP1 || 'Computer';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-upper p").innerHTML =
                                challenge.NameP2 || 'Computer';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right p").innerHTML =
                                String(challenge.TicketAmount);
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left p").innerHTML =
                                String(challenge.TicketAmount);
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right .card-valute").innerHTML =
                                'DIN';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left .card-valute").innerHTML =
                                'DIN';
                        };
                    }
                    else {
                        coinImage.src = this.imageTailPath;
                        coinImage.onload = function () {
                            ctx_1 ? ctx_1.drawImage(coinImage, 30, -40, canvasElement.width(80), canvasElement.height(150)) : '';
                            document.getElementsByClassName("coins-card-id-" + challenge.ChallID) ?
                                test_1 = document.getElementsByClassName("coins-card-id-" + challenge.ChallID)[0] : '';
                            test_1 ? test_1.querySelector('.coins-body-right') ? test_1.querySelector('.coins-body-right')
                                .classList.add('my-glower', 'no-animation') : '' : '';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-upper p").innerHTML =
                                challenge.NameP1 || 'Computer';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-upper p").innerHTML =
                                challenge.NameP2 || 'Computer';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right p").innerHTML =
                                String(challenge.TicketAmount);
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left p").innerHTML =
                                String(challenge.TicketAmount);
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right .card-valute").innerHTML =
                                'DIN';
                            document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left .card-valute").innerHTML =
                                'DIN';
                        };
                    }
                }
                else {
                    coinImage.src = this.dice2Path;
                    coinImage.onload = function () {
                        ctx_1 ? ctx_1.drawImage(coinImage, -10, -110, canvasElement.width(110), canvasElement.height(230)) : '';
                    };
                }
            }
        }
    };
    return Render;
}());
exports.default = Render;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/coin-animation/render.ts
// module id = 1997
// module chunks = 4